import React, { Component } from 'react';
import Score from 'components/Score';
import { metricsForPQLesson } from '../util/metrics';

import 'sass/components/lesson-overview';

export default class LessonOverview extends Component {

    constructor (props) {
        super(props);

    }

    getScore(value, boxClass, index){
        return(
            <Score
                key={index}
                value={value}
                boxClass={boxClass}
            />
        );
    }

    getSplitScore(value, value2, boxClass, index){
        return(
            <Score
                key={index}
                value={value}
                value2={value2}
                boxClass={boxClass}
            />
        );
    }

    render () {
        let classCount = [];
        for (let i = this.props.startIndex; i <= this.props.endIndex; i++) {
            classCount.push(<div className={'key-entry'} key={i}>{i % 10 === 0 ? i : ' '}</div>);
        }
        let classCountTicks = [];
        for (let i = this.props.startIndex; i <= this.props.endIndex; i++) {
            let className = 'key-entry';
            if (i % 10 === 0 ) className += ' tick-mark';
            classCountTicks.push(<div className={className} key={`tick_${i}`}> </div>);
        }

        let student = this.props.student;
        let soundfarm = [];
        let wordbuilder = [];
        let tracerace = [];
        let soundblend = [];
        let reallywriting = [];
        let reallyreading = [];

        for(let i = this.props.startIndex; i <= this.props.endIndex; i++){
            if(student.metrics[`lesson_${i}`]){
                let lesson = student.metrics[`lesson_${i}`];
                let data = metricsForPQLesson(lesson);

                soundfarm.push(this.getSplitScore(data.sf.one.percent, data.sf.two.percent, 'co   mpact', i + '_sf'));
                wordbuilder.push(this.getScore(data.wb.one.percent, 'compact', i + '_wb'));
                tracerace.push(this.getSplitScore(data.tr.one.percent, data.tr.two.percent, 'compact', i + '_tr'));
                soundblend.push(this.getSplitScore(data.sb.one.percent, data.sb.two.percent, 'compact', i + '_sb'));
                reallywriting.push(this.getSplitScore(data.rw.one.percent, data.rw.two.percent, 'compact', i + '_rw'));
                reallyreading.push(this.getScore(data.rr.one.percent, 'compact', i + '_rr'));
            }
            else{
                soundfarm.push(this.getSplitScore(0, 0, 'compact', i + '_sf'));
                wordbuilder.push(this.getScore(0, 'compact', i + '_wb'));
                tracerace.push(this.getSplitScore(0, 0, 'compact', i + '_tr'));
                soundblend.push(this.getSplitScore(0, 0, 'compact', i + '_sb'));
                reallywriting.push(this.getSplitScore(0, 0, 'compact', i + '_rw'));
                reallyreading.push(this.getScore(0, 'compact', i + '_rr'));
            }
        }

        return (
            <div className="lesson-overview">
                <div className="lesson-count">
                    <div className="overview-label">&nbsp;</div>
                    <div className="score-row">
                        {classCount}
                    </div>
                    <div className="overview-label">&nbsp;</div>
                    <div className="tick-row">
                        {classCountTicks}
                    </div>
                </div>
                <div className="scores-row">
                    <div className="overview-label">Sound Farm:</div>
                    {soundfarm}
                </div>
                <div className="scores-row word-builder">
                    <span className="overview-label">Word Builder:</span>
                    {wordbuilder}
                </div>
                <div className="scores-row">
                    <span className="overview-label">Trace Race:</span>
                    {tracerace}
                </div>
                <div className="scores-row">
                    <span className="overview-label">Sound Blend:</span>
                    {soundblend}
                </div>
                <div className="scores-row">
                    <span className="overview-label">Really Writing:</span>
                    {reallywriting}
                </div>
                <div className="scores-row">
                    <span className="overview-label">Really Reading:</span>
                    {reallyreading}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./js/components/LessonOverview.js